$(function() {

  $('.home-Campaign_SliderItems').slick({
    infinite: true,
    dots: true,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

}());
